import React from 'react';
import {
    Redirect,
    Switch,
    Route
} from 'react-router-dom';
import GeneratePassword from '../pages/components/Auth/GeneratePassword';
import MasterPublicLayout from "../layout/MasterPublicLayout";
import EmailVerified from '../pages/components/EmailVerified/EmailVerified';
import PaymentSuccess from '../pages/components/Settings/MySubscription/PaymentSuccess';
import PaymentCancel from '../pages/components/Settings/MySubscription/PaymentCancel';

const AdditionalPublicRoutes = () => {

    return (
        <MasterPublicLayout>
            <Switch>
                <Route
                    path='/generate-password'
                    exact={true}
                    component={GeneratePassword}
                />
                <Route 
                    path="/email-verified" 
                    component={EmailVerified}
                    exact={true} 
                />
                <Route 
                    path="/payment-success"
                    component={PaymentSuccess}
                    exact={true}
                />
                 <Route 
                    path="/payment-cancelled"
                    component={PaymentCancel}
                    exact={true}
                />
                <Redirect to='/auth/login' />
            </Switch>
        </MasterPublicLayout>
    )
}

export default AdditionalPublicRoutes